import { get } from 'es-toolkit/compat';
import React from 'react';

import getErrorObj from 'lib/errors/getErrorObj';

import useAddChain from './useAddChain';
import useProvider from './useProvider';
import useSwitchChain from './useSwitchChain';

const SWITCH_DELAY = 1000; // 1 second delay

export default function useSwitchOrAddChain() {
  const { wallet, provider } = useProvider();
  const addChain = useAddChain();
  const switchChain = useSwitchChain();

  return React.useCallback(async() => {
    if (!wallet || !provider) {
      return;
    }

    try {
      return await switchChain();
    } catch (error) {
      const errorObj = getErrorObj(error);
      const code = get(errorObj, 'code');
      const originalErrorCode = get(errorObj, 'data.originalError.code');
      const message = String(get(errorObj, 'message') || '');

      // This error code indicates that the chain has not been added to Wallet.
      if (code === 4902 || originalErrorCode === 4902 || message.includes('Try adding the chain')) {
        try {
          await addChain();
          // Add a delay before switching to ensure the network is properly added
          await new Promise(resolve => setTimeout(resolve, SWITCH_DELAY));
          return await switchChain();
        } catch (addError) {
          // 如果添加网络失败，检查是否是网络已存在的错误
          const addErrorObj = getErrorObj(addError);
          const addErrorCode = get(addErrorObj, 'code');
          const addErrorMessage = String(get(addErrorObj, 'message') || '');

          if (addErrorCode === -32603 || addErrorMessage.includes('already exists')) {
            // 如果网络已存在，直接尝试切换
            await new Promise(resolve => setTimeout(resolve, SWITCH_DELAY));
            return await switchChain();
          }
          throw addError;
        }
      }

      throw error;
    }
  }, [ addChain, provider, wallet, switchChain ]);
}
